import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { useParams, useHistory } from "react-router";
import { useApiEffect } from "nsitools-react";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { SubActivityDetailPage } from "./SubActivityDetailPage";
import { SubActivityApi } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { SubActivityJudgePage } from "./SubActivityJudgePage";

export interface ISubActivityItemPageProps {}

export const SubActivityItemPage: React.FunctionComponent<ISubActivityItemPageProps> = (props) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idSubActivity = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const api = useApiService(SubActivityApi);
  const [displayName, loading] = useApiEffect(
    () => api.getDisplayName(idSubActivity, currentLanguage.languageCode),
    [idSubActivity],
  );

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.SubActivities), route: ERoutes.subActivity },
        { text: idSubActivity > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsSubActivity"
        onChange={(newTabId) => history.push(`${ERoutes.subActivity}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.subActivity} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<SubActivityDetailPage idSubActivity={idSubActivity} editMode={state === "edit"} />}
        />
        <Tab id="judges" title={t(ETLCodes.Judges)} panel={<SubActivityJudgePage subActivityId={idSubActivity} />} />

        {/* <Tab id="contest" title={t(ETLCodes.Contest)} disabled /> */}
      </ProtectedTabs>
    </PageBase>
  );
};
